import { lazy } from "react";
import { AppRoute } from "../../../models/AppRoute";
import { DCPPathNames, UserPermissions } from "../../../utilities/Constants";

//#region - Lazy-loaded component
const CustomerActivity = lazy(() => import("../views/CustomerActivity"));
const CustomerStatements = lazy(() => import("../views/CustomerStatements"));
//#endregion

const customerRoutes: AppRoute[] = [
    {
        path: DCPPathNames.CUSTOMER_ACTIVITY_PATH,
        name: "My Transactions",
        element: <CustomerActivity />,
        meta: {
            requiresAuthorization: true,
            authorize: [UserPermissions.DOWNLOAD_DOCUMENTS],
            menu: {
                label: "My Transactions",
                icon: ["fas", "file-invoice"],
            },
        },
    },
    {
        path: DCPPathNames.CUSTOMER_STATEMENTS_PATH,
        name: "My Statements",
        element: <CustomerStatements />,
        meta: {
            requiresAuthorization: true,
            authorize: [UserPermissions.DOWNLOAD_DOCUMENTS],
            menu: {
                label: "My Statements",
                icon: ["fas", "book"],
            },
        },
    },
];

export default customerRoutes;
